import React, { FunctionComponent } from 'react'
import { SlideInProps, SlideOutProps, SlideProps } from './types'
import styles from './style.module.scss'
import clsx from 'clsx'

type BaseSlideComponent = FunctionComponent<SlideProps>
type SlideInVariantComponent = FunctionComponent<SlideInProps>
type SlideOutVariantComponent = FunctionComponent<SlideOutProps>
export type SlideComponent = BaseSlideComponent & {
  In: SlideInVariantComponent
  Out: SlideOutVariantComponent
}

const BaseSlide: BaseSlideComponent = ({ translateBy, condition = true, children, duration = 'Medium', fade = false, testNameSpace = '', ...props }) => {
  const shouldNotSlide = !condition
  if (shouldNotSlide) {
    return children
  }

  // Typeguard to make compiler get correct prop to use for direction
  const isSlideIn = 'from' in props
  const type = isSlideIn ? 'In' : 'Out'
  const directionPrefix = isSlideIn ? 'From' : 'To'
  const direction = isSlideIn ? props.from : props.to
  const fadePrefix = fade ? 'With' : 'Without'

  const shouldApplyTestNameSpace = testNameSpace.length > 0
  const testNameSpaceSuffix = `slide-${type.toLowerCase()}`

  const slideAnimation = `slide${type}${directionPrefix}${direction}By${translateBy}${fadePrefix}Fade`
  const slideStyles = clsx(styles.slide, styles[slideAnimation], styles[`duration${duration}`])

  return (
    <div className={slideStyles} {...(shouldApplyTestNameSpace && { 'data-testid': `${testNameSpace}-${testNameSpaceSuffix}` })}>
      {children}
    </div>
  )
}

export const Slide = BaseSlide as SlideComponent

const SlideIn: SlideInVariantComponent = ({ from, ...props }) => {
  return <Slide {...props} from={from} />
}

const SlideOut: SlideOutVariantComponent = ({ to, ...props }) => {
  return <Slide {...props} to={to} />
}

Slide.In = SlideIn
Slide.Out = SlideOut
